/*
    2020-1-06
    曹秀芳
    制作 模拟量图表速览 页面
*/ 
<template>
  <div class="AnalogChartQuickView mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/AnalogChartQuickView"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <!-- 页面部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <a download=""></a>
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.navTwentyOne')}}</h1>
              <div class="machineSeach">
                <label style="margin-right:10px;font-size:12px;">{{$t('AnalogChartQuickView.DashBoard')}}</label>
                <el-cascader
                  class="idStyle"
                  @change="getShiftTime()"
                  :placeholder="$t('SingleTireStepAnalysis.placehoder1')"
                  expand-trigger="hover"
                  :options="options"
                  filterable
                  v-model="machineID">
                </el-cascader>
              </div>
            </div>
            <!-- 页面主体部分-->
            <div class="my" v-for="(item,inde) in AnalogChart" :key="inde">
              <div class="fit">
                  <div class="fit-title">{{item.name}}</div>
                  <div style="display:flex;justify-content:left;margin-bottom:20px;">
                    <!-- date 选择日期 -->
                    <div class="block">
                        <el-date-picker 
                        v-model="item.datevalue"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :placeholder="$t('AnalogChartQuickView.Choosedate')"
                        :picker-options="item.pickerOptions"
                        @change="kongdata(item)"
                        >
                        </el-date-picker>
                    </div>
                    <!-- time 选择时间 -->
                    <div class="searchnavtime">
                        <el-time-select
                          v-model="item.timevalue"
                          :picker-options="nowTimeS()"
                          :placeholder="$t('AnalogChartQuickView.Choosetime')"
                          @change="kongtime(item)">
                        </el-time-select>
                    </div>
                    <div class="fit-body flexes">
                      <el-button 
                        size="medium"
                        class="direction-fit-time left-fit-time" 
                        @click="leftFit(item)"
                      >
                        <span v-show="item.pageInfo.list.length === 0">0/0</span>
                        <span v-show="item.pageInfo.list.length !== 0">{{item.product}}/{{item.pageInfo.total}} </span>
                        <i class="el-icon-arrow-left"></i>
                      </el-button>
                      <div class="flexes">
                        <div 
                          :class="{'fit-time':true,'active':item.fitTimeNum === index}" 
                          v-for="(ite,index) in item.pageInfo.list" 
                          :key="ite.id"
                          @click="getCodeItem(item,ite,index)"
                        >
                          <p>{{ite.startTime | formatDate}}</p>
                          <p>{{ite.startTime | formatTime}}</p>
                        </div>
                      </div>
                      <el-button 
                        size="medium"
                        class="direction-fit-time right-fit-time" 
                        @click="rightFit(item)"
                      >
                        <i class="el-icon-arrow-right"></i>
                      </el-button>
                    </div>
                  </div>
                  <div>
                    <div class="flexes fit-img-body">
                      <el-button 
                        v-show="item.pageInfo.list.length !==0"
                        size="small"
                        class="direction-fit-time buttonH" 
                        @click="leftFitTime(item)"
                      ><i class="el-icon-arrow-left"></i>
                      </el-button>
                      <div v-loading="item.loadingImg" style="width:1000px;height:400px;">
                        <img v-show="item.pageInfo.list.length !==0" style="width:100%;height:100%;" :src="item.imgUrl">
                      </div>
                      <el-button 
                        v-show="item.pageInfo.list.length !==0"
                        size="small"
                        class="direction-fit-time buttonH" 
                        @click="rightFitTime(item)"
                      >
                        <i class="el-icon-arrow-right"></i>
                      </el-button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
// //引入转换时间文件
import { formatDate } from '../assets/js/date.js'
export default {
  name: 'AnalogChartQuickView',
  components: {
    leftNav
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      // 选中的工厂id
      factoryId:'',
      fullscreenLoading: false,
      //我的代码
      AnalogChart:[],//模拟量图表
      pageSize:10,
      pageNum:1,//当前页面
      // datevalue:new Date(),//日期
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() > Date.now();
      //   }
      // },
      // timevalue:new Date().getHours()+':00:00',//时间
      // date:null
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  mounted() {
   this.getManiceList()
  },
  methods: {
    // 接口：获取DashBoard列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/analogChartQuickView/dashBoard',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
           let optionsArr = res.data.msg.map(item=>{
            return {
              value:item.id,
              label:item.name,
            }
          })
          _this.options = optionsArr
          if(_this.options.length === 1){
            _this.machineID[0] = _this.options[0].value
            _this.getCodeList()
          }
          
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    //工厂下拉框选中状态变化时
    getShiftTime(){
      this.getCodeList()
    },
    //总接口
    getCodeList() {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/analogChartQuickView/getCodeList',
        params:{
          language: _this.$store.state.lang,
          pageSize:_this.pageSize,
          pageNum:_this.pageNum,
          grafanaId:_this.machineID[0]
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          res.data.msg.forEach(item=>{
            item.pageNum = 1
            //当前激活样式
            item.fitTimeNum = item.pageInfo.list.length-1
            item.product = 1//当前选中的时间
            //图片路径
            item.imgUrl = ''
            //图片loading
            item.loadingImg = true
            item.next = true
            item.datevalue =new Date(),//日期
            item.pickerOptions= {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            }
            item.timevalue=new Date().getHours()+':00'//时间
            item.date=null
          })
          _this.AnalogChart = res.data.msg
        } 
      }).then(function(){
        _this.AnalogChart.forEach(item=>{
          if(item.pageInfo.list.length!== 0){
            _this.getImage(item,item.pageInfo.list[item.pageInfo.list.length-1])
          }else{
            item.loadingImg = false
          }
        })
      })
    },
    //接口：翻页
    getCode(item,x) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/analogChartQuickView/getCode',
        params:{
          language: _this.$store.state.lang,
          pageSize:_this.pageSize,
          pageNum:item.pageNum,
          grafanaId:item.grafanaId,
          time:item.date
        }
      }).then(function(res){
        if (res.data.success === 'true') {
           _this.AnalogChart.forEach(item=>{
             if(item.grafanaId === res.data.msg.grafanaId){
                item.pageInfo.list = res.data.msg.pageInfo.list
                item.pageInfo.total = res.data.msg.pageInfo.total
                item.fitTimeNum = item.pageInfo.list.length-1
                if(x === 'datetime'){
                  item.product = 1
                  item.pageNum = 1
                }else{
                  if((item.pageInfo.list.length-item.fitTimeNum)+((item.pageNum-1)*_this.pageSize)<item.pageInfo.total){
                    item.product = (item.pageInfo.list.length-item.fitTimeNum)+((item.pageNum-1)*_this.pageSize)
                    
                  }
                }
             }
           })
        } 
      }).then(function(){
          if(item.pageInfo.list.length!== 0){
            _this.getImage(item,item.pageInfo.list[item.pageInfo.list.length-1])
          }else{
            item.loadingImg = false
          }
      })
    },
    //左翻页
    leftFit(item){
      if(item.next === false){
        return
      }else{
        if( item.pageNum*this.pageSize<item.pageInfo.total){
          item.pageNum++
          this.getCode(item)
        }
      }
    },
    //右翻页
    rightFit(item){
      if(item.next === false){
        return
      }else{
        if(item.product-this.pageSize>=1){
          item.pageNum--
          this.getCode(item)
        }
      }
    },
    //接口：获取grafana图片
    getImage(item,ite) {
      item.next = false
      item.loadingImg = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/analogChartQuickView/getImage',
        params:{
          language: _this.$store.state.lang,
          grafanaId:item.grafanaId,// 当前85000对应的仪表盘Id
          startTime:ite.startTime, //85000的开始时间
          endTime:ite.endTime //85000的结束时间
        }
      }).then(function(res){
        if (res.data.success === 'true') {
           item.imgUrl = res.data.msg
           item.loadingImg = false
           item.next = true
        } 
      }).catch(function(){
        item.loadingImg = false
        item.next = true
      })
    },
    //点击每一个code
    getCodeItem(item,ite,index){
      if(item.next === false){
        return
      }else{
        item.fitTimeNum = index//激活样式
        item.product = (item.pageInfo.list.length-item.fitTimeNum)+(this.pageSize*(item.pageNum-1))//变更序号
        this.getImage(item,ite)//请求图片
      }
    },
    //左翻图片
    leftFitTime(item){
      if(item.next === false){
        return
      }else{
        if(item.fitTimeNum>0){
          item.fitTimeNum--
          item.product = (item.pageInfo.list.length-item.fitTimeNum)+(this.pageSize*(item.pageNum-1))
          this.getImage(item,item.pageInfo.list[item.fitTimeNum])
        }
      }
    },
    //右翻图片grafanaId,arr
    rightFitTime(item){
      if(item.next === false){
        return
      }else{
        if(item.fitTimeNum<item.pageInfo.list.length-1){
          item.fitTimeNum++
          item.product = (item.pageInfo.list.length-item.fitTimeNum)+(this.pageSize*(item.pageNum-1))
          this.getImage(item,item.pageInfo.list[item.fitTimeNum])
        }
      }
      
    },
    //日期输入框
    kongdata(item){
      if(item.datevalue === null){
          item.datevalue = null
      }else{
        let tv = item.timevalue+':00'
        item.date = item.datevalue + ' ' + tv
        if(item.timevalue !== null){
            this.getCode(item,'datetime')
        }
      }
      
    },
    kongtime(item){//时间输入框
      if(item.timevalue === null){
          item.timevalue = null
      }else{
        let tv = item.timevalue+':00'

        if(typeof(item.datevalue) == 'string'){
          item.date = item.datevalue + ' ' + tv
        }else{
          let y = item.datevalue.getFullYear()
          let m = item.datevalue.getMonth() + 1
          if(m<10){
            m='0'+m
          }
          let d = item.datevalue.getDate()
          if(d<10){
            d='0'+d
          }
          item.date = y +'-'+ m+'-'+d + ' ' + tv
          
        }

        if(item.datevalue !== null){
            this.getCode(item,'datetime')
        }
      }
    },
    nowTimeS(){//限制选择的时间范围
      let y = new Date().getFullYear()
      let m = new Date().getMonth()+1
      if(m<10){
          m ='0'+ m
        }
      let d = new Date().getDate()
      if(d<10){
          d ='0'+ d
        }
      let nowTime = y +'-'+ m +'-'+ d

      if(this.datevalue === nowTime){
        let t = new Date()+''
        let nowTimeEnd = t.slice(16,21)
        return {
          start: '00:00',
          step: '01:00',
          end: nowTimeEnd
        }
      }else{
        return {
          start: '00:00',
          step: '01:00',
          end: '23:00'
        }
      }
    },
  },
  filters: {//转换时间发方法
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yy/MM/dd')
    },
    formatTime (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'hh:mm:ss')
    }
  }
}
</script>
<style scoped>
.AnalogChartQuickView{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
}
/* 我的样式 */
.flexes{
    display: flex;
}
.my{
    padding: 20px;
}
.fit{
  background-color: #fff;
  border-radius: 3px;
	box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
}
.fit-title{
  color: rgba(80, 80, 80, 1);
	font-size: 16px;
	line-height: 3;
	text-align: left;
	font-weight: bold;
  text-align: center;
}
.fit-body{
  justify-content: center;
}
.direction-fit-time{
	box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.13);
	border-radius: 4px;
	font-size: 14px;
	line-height: 2;
	text-align: center;
  margin:0 5px;
  padding: 0 6px;
}
.left-fit-time{
  width: 70px;
}
.right-fit-time{
  padding: 0 10px;
}
.fit-time{
  color: rgba(80, 80, 80, 1);
	border-radius: 3px;
	font-size: 12px;
	line-height: 1.5;
	box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.15714285714285708);
	text-align: center;
  padding:0 5px;
  cursor:pointer;
}
.active{
  color: rgba(255, 255, 255, 1);
	background-color: rgba(0, 139, 213, 1);
}
.buttonH{
  height: 40px;
  margin: 170px 20px 0;
  padding: 0 10px;
}
.fit-img-body{
  justify-content: center;
  padding-bottom: 20px;
}
/* element-ui样式 */
.block{
  margin-left: 5px;
}
.searchnavtime{
  margin-left: 5px;
}
.block .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 140px;
}
.searchnavtime .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100px;
    
}
</style>

